import { UserIcon } from '@heroicons/react/24/outline';

import { OfficerDetail } from '@/services/api/generated/policeReportsService';

interface OfficersSectionProps {
  officers: OfficerDetail[];
}

export const OfficersSection = ({ officers }: OfficersSectionProps) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <div className="flex items-center space-x-2 mb-4">
        <UserIcon className="h-5 w-5 text-gray-400" />
        <h2 className="text-lg font-semibold text-gray-900">
          Involved Officers ({officers.length})
        </h2>
      </div>

      <div className="space-y-4">
        {officers.map((officer, index) => (
          <div key={index} className="border border-gray-200 rounded-lg p-4">
            <div className="flex items-start justify-between">
              <div className="flex items-center space-x-3">
                <div className="flex-shrink-0">
                  <div className="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center">
                    <UserIcon className="h-5 w-5 text-gray-500" />
                  </div>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-gray-900">
                    {officer.name}
                  </h3>
                  {officer.badge_number && (
                    <p className="text-sm text-gray-500">
                      Badge: {officer.badge_number}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {officer.context && (
              <div className="mt-3">
                <p className="text-sm text-gray-600">{officer.context}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
